export default "__VITE_ASSET__029c9036__"